import styled from 'styled-components';

import { InfoBlock } from 'components';

export const Card = styled(InfoBlock)`
  display: flex;
  flex-direction: column;
`;

export const Divider = styled.p`
  height: 1px;
  width: 100%;
  margin: 16px 0;
  background-color: ${({ theme }) => theme.config.common.border};
`;
